import axios from '@/plugins/axios';

function generateFilterParams(filters) {
  const ret = {};
  const filterParameter = { ...filters };

  if (filterParameter.states != null && filterParameter.states.length > 0) {
    filterParameter.states = filterParameter.states.join(',');
  }

  if (filterParameter.lender != null && filterParameter.lender.length > 0) {
    filterParameter.lender = filterParameter.lender.join(',');
  }

  const ary = Object.keys(filterParameter).map((key) => ({
    name: key,
    value: filterParameter[key],
  }));

  ary.filter((i) => i.value != null && i.value !== '')
    .forEach((i) => { ret[`filters[${i.name}]`] = i.value; });

  return ret;
}

function formatDiscount(discount, type) {
  const fixed = discount.toFixed(2);
  if (type === 'Percentage') {
    return `${fixed}%`;
  } else {
    return `$${fixed}`;
  }
}

const state = {
  items: [],
  loading: false,
  pagination: {
    sortDesc: [true],
    page: 1,
    itemsPerPage: 10,
    sortBy: [],
  },
  filters: {},
  totalItems: 0,
};

const mutations = {
  setItems: (currentState, { items, totalItems }) => {
    currentState.items = items;
    currentState.totalItems = totalItems;
  },
  setItem: (currentState, item) => {
    const index = currentState.items.findIndex((x) => x.id === item.id);
    currentState.items[index] = item;
  },
  setPagination: (currentState, payload) => {
    currentState.pagination = payload;
  },
  setFilters: (currentState, payload) => {
    currentState.filters = generateFilterParams(payload);
  },
  setLoading: (currentState, payload) => {
    currentState.loading = payload;
  },
};

const actions = ({
  getItems({ commit }) {
    return new Promise((resolve) => {
      commit('setLoading', true);
      const params = {
        page: state.pagination.page,
        rowsPerPage: state.pagination.itemsPerPage,
        ...state.filters,
      };
      axios.get('/discountCodes', { params })
        .then((response) => {
          commit('setItems', response.data);
          resolve();
        }).finally(() => commit('setLoading', false));
    });
  },
  setPagination({ commit, dispatch }, paginationInfo) {
    commit('setPagination', paginationInfo);
    dispatch('getItems');
  },
  getDiscountCode(_, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/discountCodes/${id}`).then((response) => {
        resolve(response.data);
      }).catch(reject);
    });
  },
  updateDiscountCode({ dispatch }, discountCode) {
    return new Promise((resolve, reject) => {
      axios.put(`/discountCodes/${discountCode.id}`, {
        discount: parseFloat(discountCode.discount),
        type: discountCode.type,
        nonExpiring: discountCode.nonExpiring,
      }).then(() => {
        dispatch('getItems');
        resolve();
      }).catch(reject);
    });
  },
  createDiscountCode({ dispatch }, discountCode) {
    return new Promise((resolve, reject) => {
      axios.post('/discountCodes').then((response) => {
        discountCode.id = response?.data?.id;
        resolve(dispatch('updateDiscountCode', discountCode));
      }).catch(reject);
    });
  },
  deleteDiscountCode(_, { id }) {
    return new Promise((resolve, reject) => {
      if (id) {
        axios.delete(`/discountCodes/${id}`)
          .then(() => {
            resolve();
          })
          .catch(reject);
      } else {
        resolve();
      }
    });
  },
});

const getters = {
  loading(currentState) {
    return currentState.loading;
  },
  pagination(currentState) {
    return currentState.pagination;
  },
  tableItems(currentState) {
    return currentState.items.map((discountCode) => ({
      ...discountCode,
      discount: formatDiscount(discountCode.discount, discountCode.type),
      createdAt: new Date(discountCode.createdAt).toLocaleString(),
      expiresAt: discountCode.nonExpiring
        ? 'non-expiring' : new Date(discountCode.expiresAt).toLocaleString(),
    }));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
